import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RootRedirect: React.FC = () => {
  const { isAuthenticated } = useAuth();
  
  // If user is authenticated, redirect to tools page
  if (isAuthenticated) {
    return <Navigate to="/studio/tools" replace />;
  }
  
  // If user is not authenticated, redirect to studio
  return <Navigate to="/studio" replace />;
};

export default RootRedirect;